import React, { useState } from 'react'
import { BaseDialog } from '@/components/dialog/base-dialog'
import { layerManage, showLayer } from '@/utils/layer'
import { Column, Row } from '@/components/layout/layout'
import classNames from 'classnames'
import { getBEMCls } from '@/utils/classname'
import Input from '../../../../../../../../../../components/input/input'
import { InkWell } from '@/components/inkwell/inkwell'
import './goods-unit.scss'
import { observer } from 'mobx-react'
import { goodsModel, GoodsModel } from '../model'
import { Switch } from 'antd'
import Iconfont from '@/components/iconfont/iconfont'
import PopoverConfirm from '@/components/popover-confirm/popover-confirm'
import { Modal } from '@/components/dialog/modal'
import { $post } from '@/api'
import $msg from '@/utils/message'
import { useDebounceFn, useMount } from 'ahooks'
import { Unit } from '@/model/types/goods'
import { shopStore } from '@/store/shop'

const ChooseGoodsUnitDialog: React.FC<{
    goodsModel: GoodsModel
    choosedId: number
    onChange: (params: { id: number; name: string }) => void
}> = observer(props => {
    const cls = (...args: string[]) => getBEMCls('choose-goods-unit', ...args)
    const [goodsUnit, setGoodsUnit] = useState(props.goodsModel.goodsUnit)

    useMount(async () => {
        if (!goodsUnit.length) {
            const result = await goodsModel.initGoodsUnit()
            setGoodsUnit(result)
        }
    })

    return (
        <BaseDialog
            isShow
            styles={{
                width: '520px',
            }}
            title="单位选择"
            renderTitle={() => (
                <div
                    className={cls('unitManage')}
                    onClick={() =>
                        showLayer(
                            <GoodsUnitManageDialog
                                onClose={async () => {
                                    const result = await goodsModel.initGoodsUnit()
                                    setGoodsUnit(result)
                                }}
                            />,
                        )
                    }
                >
                    <span data-margin-right-2>
                        <Iconfont name="icon6shezhi-20" size={16}></Iconfont>
                    </span>
                    单位管理
                </div>
            )}
            onClose={() => layerManage.pop()}
        >
            <Column className={cls('content')}>
                <Column>
                    <span className={cls('title')}>计重单位</span>
                    <div>
                        {goodsUnit
                            .filter(val => [2, 4].includes(val.id))
                            .filter(val => val.status !== -1)
                            .map(item => (
                                <InkWell
                                    key={item.id}
                                    className={classNames(cls('unit-item'), {
                                        [cls('unit-item', 'active')]: props.choosedId === item.id,
                                    })}
                                    onClick={() => {
                                        props.onChange({
                                            id: item.id,
                                            name: item.name,
                                        })
                                        layerManage.pop()
                                    }}
                                >
                                    {item.name}
                                </InkWell>
                            ))}
                    </div>
                </Column>
                <Column data-margin-bottom-20>
                    <span className={cls('title1')}>计数单位</span>
                    <div>
                        {goodsUnit
                            .filter(item => ![2, 4].includes(item.id))
                            .filter(val => val.status !== -1)
                            .map(val => {
                                return (
                                    <InkWell
                                        key={val.id}
                                        className={classNames(cls('unit-item'), {
                                            [cls('unit-item', 'active')]: props.choosedId === val.id,
                                        })}
                                        onClick={() => {
                                            props.onChange(val)
                                            layerManage.pop()
                                        }}
                                    >
                                        {val.name}
                                    </InkWell>
                                )
                            })}
                    </div>
                </Column>
            </Column>
        </BaseDialog>
    )
})

export const GoodsUnitManageDialog: React.FC<{
    onClose: () => void
}> = props => {
    const cls = (...args: string[]) => getBEMCls('choose-goods-unit', ...args)
    const [visible, setVisible] = useState(false)
    const [unitName, setUnitName] = useState('')
    const [goodsDefaultUnit, setGoodsDefaultUnit] = useState(goodsModel.goodsDefaultUnit)
    const [goodsCustomUnit, setGoodsCustomUnit] = useState(goodsModel.goodsCustomUnit)

    const hidden = () => {
        setVisible(false)
    }

    const deleteUnitDialog = (item: Unit) => {
        const close = () => layerManage.pop()
        showLayer(
            <Modal
                isShow
                type="danger"
                onClose={close}
                onCancel={close}
                onConfirm={() => {
                    close()
                    if (checkoutStatus() && item.status === 0) return $msg('error', '至少保留一个单位')
                    deleteUnitDebounce.run({ ...item })
                }}
                style={{ height: '150px' }}
            >
                <div>
                    <div data-font-size-20 data-color-000 data-font-weight-600>
                        确认删除此单位吗？
                    </div>
                    <div data-color-999 data-font-size-14 data-margin-top-8>
                        自定义单位删除后，原统计数据不受影响
                    </div>
                </div>
            </Modal>,
        )
    }

    /**
     * 删除单位
     * @param unit
     */
    const deleteUnit = (unit: { id: number; name: string }) => {
        $post({
            url: 'goods/editunit',
            params: {
                unit_id: unit.id,
                unit_name: unit.name,
                status: -1,
            },
        }).then(async res => {
            const result = await goodsModel.getGoodsCustomUnit()
            setGoodsCustomUnit(result)
            $msg('success', '删除成功')
        })
    }
    const deleteUnitDebounce = useDebounceFn(deleteUnit)

    /**
     * 更新单位状态
     * @param unit
     */
    const updatecountUnitStatus = (unit: { id: number; name: string; status: number }) => {
        $post({
            url: 'goods/editunit',
            params: {
                unit_id: unit.id,
                unit_name: unit.name,
                status: unit.status === 0 ? -1 : 0,
            },
        }).then(async res => {
            const result = await goodsModel.getGoodsUnit()
            // console.log(result)
            setGoodsDefaultUnit(result)
            $msg('success', '设置成功')
        })
    }
    const updatecountUnitStatusDebounce = useDebounceFn(updatecountUnitStatus)

    /**
     *  计数单位必须保留一个 检查是否剩只剩下一个
     */
    const checkoutStatus = () => {
        const defalutUnitList = goodsDefaultUnit.filter(val => ![2, 4].includes(val.id)).filter(val => val.status === 0)
        const customUnitList = goodsCustomUnit.filter(val => val.status === 0)

        if (defalutUnitList.length + customUnitList.length === 1) {
            return true
        } else {
            return false
        }
    }

    const addCustomUnit = () => {
        $post({
            url: '/goods/addcustomunit',
            params: {
                unit_name: unitName,
            },
        })
            .then(async res => {
                const result = await goodsModel.getGoodsCustomUnit()
                setGoodsCustomUnit(result)
                $msg('success', '添加成功')
            })
            .catch(e => {
                $msg('error', e.message)
            })
    }
    /**
     *  获取可以新增自定义单位的数量
     */
    const getCustomUnitCount = () => {
        const shopInfo = shopStore.shopInfo
        switch (shopInfo!.shop_version) {
            case 0:
                return 0
            case 1:
                return 5
            case 2:
                return 15
        }

        return 0
    }

    return (
        <BaseDialog
            styles={{ width: '576px' }}
            isShow
            title="单位管理"
            onClose={() => {
                layerManage.pop()
                props.onClose()
            }}
        >
            <Column className={cls('content')}>
                <Column>
                    <span className={cls('title')}>计重单位</span>
                    <div>
                        {goodsDefaultUnit
                            .filter(val => [2, 4].includes(val.id))
                            .map(item => (
                                <div
                                    key={item.id}
                                    className={classNames(cls('unit-item1'))}
                                    onClick={() => {
                                        const unitlist = goodsDefaultUnit
                                            .filter(val => [2, 4].includes(val.id))
                                            .filter(item => item.status === 0)
                                        // 计价单位数组中只剩下一个开对，并且当前当前状态为开，返回
                                        if (unitlist.length === 1 && item.status === 0)
                                            return $msg('error', '至少保留一个单位')
                                        updatecountUnitStatusDebounce.run({ ...item })
                                    }}
                                >
                                    <span data-margin-bottom-8>{item.name}</span>
                                    <Switch size="small" checked={item.status === 0}></Switch>
                                </div>
                            ))}
                    </div>
                </Column>
                <Column data-margin-bottom-20>
                    <Row className={cls('title1')}>
                        <span>计数单位</span>
                        {getCustomUnitCount() > 0 && (
                            <PopoverConfirm
                                trigger="click"
                                visible={visible}
                                onCancel={() => {
                                    hidden()
                                }}
                                onConfirm={() => {
                                    hidden()
                                    addCustomUnit()
                                }}
                                disabled={unitName.trim().length === 0}
                                onVisibleChange={visible => {
                                    if (goodsCustomUnit.length === getCustomUnitCount()) return
                                    setVisible(visible)
                                    setUnitName('')
                                }}
                                placement="topRight"
                                content={
                                    <div className={cls('input')}>
                                        <Input
                                            styles={{ height: '40px' }}
                                            value={unitName}
                                            maxLength={3}
                                            onChange={e => setUnitName(e.target.value)}
                                            inputsuffix={() => (
                                                <div data-width-40 data-text-align-right data-color-999>
                                                    {unitName.length > 3 ? 3 : unitName.length}/3
                                                </div>
                                            )}
                                        ></Input>
                                    </div>
                                }
                            >
                                <span
                                    className={cls(
                                        'title1',
                                        goodsCustomUnit.length === getCustomUnitCount() ? 'tip1' : 'tip',
                                    )}
                                >
                                    +新增单位 {goodsCustomUnit.length}/{getCustomUnitCount()}
                                </span>
                            </PopoverConfirm>
                        )}
                    </Row>
                    <div>
                        {goodsDefaultUnit
                            .filter(val => ![2, 4].includes(val.id))
                            .map(item => (
                                <div
                                    className={classNames(cls('unit-item1'))}
                                    key={item.id}
                                    onClick={e => {
                                        if (checkoutStatus() && item.status === 0)
                                            return $msg('error', '至少保留一个单位')
                                        updatecountUnitStatusDebounce.run({ ...item })
                                    }}
                                >
                                    <span data-margin-bottom-8>{item.name}</span>
                                    <Switch checked={item.status === 0} size="small"></Switch>
                                </div>
                            ))}
                        {goodsCustomUnit.map(item => (
                            <div
                                className={classNames(cls('unit-item1'))}
                                onClick={() => {
                                    deleteUnitDialog(item)
                                }}
                                key={item.id}
                            >
                                <span data-margin-bottom-8>{item.name}</span>
                                <Iconfont name="iconerror" size={18}></Iconfont>
                            </div>
                        ))}
                    </div>
                </Column>
            </Column>
        </BaseDialog>
    )
}

export default ChooseGoodsUnitDialog
